import {apiFetch} from "./General";

export const getWhatshot = (callback, errorCallback) => {

    apiFetch('whatshot', '', callback, errorCallback);
}
